import { createSliceContext } from "./CreateSliceContext";

interface BreadcrumbSliceProps {
  location: Location;
  activeTitle: string;
  countryCode: string;
  cityName?: string;
  statePath?: { path: { alias: string } };
  cityPath?: { path: { alias: string } };
  cityParentAlias?: string;
}

const defaultBreadcrumbSliceValues: BreadcrumbSliceProps = {
  location: { pathname: "/" } as Location,
  activeTitle: "",
  countryCode: "",
  cityName: "",
  statePath: undefined,
  cityPath: undefined,
  cityParentAlias: "",
};

export const {
  Provider: BreadcrumbSliceProvider,
  useContext: useBreadcrumbSliceContext,
} = createSliceContext<BreadcrumbSliceProps>(
  "Breadcrumb",
  defaultBreadcrumbSliceValues
);
